import { render, staticRenderFns } from "./ExistemSomenteNaBdgdMapa.vue?vue&type=template&id=74e11413&"
import script from "./ExistemSomenteNaBdgdMapa.vue?vue&type=script&lang=js&"
export * from "./ExistemSomenteNaBdgdMapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports